const isProd = process.env.NODE_ENV === 'production';

const logger = {
  debug: (...args: any[]) => { if (!isProd) console.debug(...args); },
  info: (...args: any[]) => { console.info(...args); },
  warn: (...args: any[]) => { console.warn(...args); },
  error: (...args: any[]) => { console.error(...args); },
};

// expose as global so existing files can use `logger` without explicit imports
;(globalThis as any).logger = logger;

export default logger;
